import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import TextField from "@components/forms/TextField/TextField";
import Button from "@components/forms/Button/Button";
import UserService from "@services/UserService";
import "./ResetPasswordPage.scss";
import { connectUser } from "@slices/userSlice";

function ResetPasswordPage() {
    const [isFetching, setFetching] = useState<boolean>(false);
    const [token, setToken] = useState<string|null>(null);
    const [email, setEmail] = useState<string|null>(null);
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmation, setConfirmation] = useState<string>('');

    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const service = new UserService;

    const handleSubmit = (e: React.FormEvent|null) => {
        if(e !== null) {
            e.preventDefault();
        }

        if(newPassword !== confirmation) {
            toast.error(t('toast.error_password_confirmation'));
            return;
        }

        const resetPassword = service.resetPassword(token, email, newPassword);
        setFetching(true);

        toast.promise(resetPassword, {
            loading: t('toast.updating'),
            success: data => t('toast.reset_password_success'),
            error: err => err.body && err.body.message || t('toast.error_fetching'),
        }, {
            duration: 5000,
        });

        resetPassword.then(data => {
            dispatch(connectUser(data.body));
        }).catch(() => {
            setFetching(false);
        });
    };

    useEffect(() => {
        setToken(searchParams.get('token'));
        setEmail(searchParams.get('email'));
    }, [searchParams]);

    return (
        <div className="p-3">
            <div className="login-container">
                <h1>🔑 {t('title.reset_password')}</h1>

                    <div className="row gy-3">
                        <div className="col-12">
                            <TextField type="password" style="secondary" label={t('page.account.new_password')} value={newPassword} placeholder={t('page.signup.input.password.placeholder')} onChange={setNewPassword}/>
                        </div>

                        <div className="col-12">
                            <TextField type="password" style="secondary" label={t('page.account.confirmation_password')} value={confirmation} placeholder={t('page.signup.input.confirmation.placeholder')} onChange={setConfirmation}/>
                        </div>

                        <div className="col-12">
                            <Button filled onClick={() => handleSubmit(null)} disabled={isFetching || newPassword === '' || confirmation === ''}>{t('page.reset_password.btn_change_password')}</Button>
                        </div>
                    </div>
                </div>
        </div>
    );
}

export default ResetPasswordPage;
